import { h } from 'preact';
import { useCallback } from 'preact/hooks';
import { memo } from 'preact/compat';

import { useDispatch, useSelector } from 'react-redux';

import { styled } from '@mui/material/styles';

import MuiAppBar from '@mui/material/AppBar';
import LinearProgress from '@mui/material/LinearProgress';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';

import { actions as drawerActions } from '../../store/state/drawer.js';
import { actions as lruDrawerActions } from '../../store/state/lruDrawer.js';
import { actions as changesDrawerActions } from '../../store/state/changesDrawer.js';
import { actions as errorActions } from '../../store/state/error.js';
import { actions as successActions } from '../../store/state/success.js';

const AppBar = styled(
  MuiAppBar,
  {}
)(({ theme }) => ({
  transition: theme.transitions.create(['background-color'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

function getNetworkActivity(state) {
  return state.network > 0;
}

function getError(state) {
  return state.error;
}

function getSuccess(state) {
  return state.success;
}

function getSelectedEndpoint(state) {
  return state.selectedEndpoint;
}

function getAppbackBackgroundColor(isFocused) {
  return '#000';
}

function Header(_props) {
  const isNetworkActive = useSelector(getNetworkActivity);
  const error = useSelector(getError);
  const success = useSelector(getSuccess);
  const selectedEndpoint = useSelector(getSelectedEndpoint);

  const dispatch = useDispatch();

  const openDrawer = useCallback(
    function openDrawer() {
      dispatch(drawerActions.OPEN());
    },
    [dispatch]
  );

  const openLruDrawer = useCallback(
    function openDrawer() {
      dispatch(lruDrawerActions.OPEN());
    },
    [dispatch]
  );

  const openChangesDrawer = useCallback(
    function openDrawer() {
      dispatch(changesDrawerActions.OPEN());
    },
    [dispatch]
  );

  const clearError = useCallback(
    function clearError() {
      dispatch(errorActions.CLEAR());
    },
    [dispatch]
  );

  const clearSuccess = useCallback(
    function clearSuccess() {
      dispatch(successActions.CLEAR());
    },
    [dispatch]
  );

  return (
    <AppBar
      position="absolute"
      sx={{ backgroundColor: getAppbackBackgroundColor() }}
    >
      <Toolbar
        sx={{
          pr: '24px',
        }}
      >
        <IconButton
          edge="start"
          aria-label="open drawer"
          onClick={openDrawer}
          sx={{
            color: '#FFF',
            marginRight: '36px',
          }}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Client Backends
        </Typography>

        <Button
          variant="outlined"
          onClick={openLruDrawer}
          sx={{
            backgroundColor: '#fff',
            fontWeight: 'bold',
            '&:hover': {
              backgroundColor: '#efefef',
            },
          }}
          color="info"
        >
          LRU
        </Button>

        {selectedEndpoint.endpointId && (
          <Button
            variant="outlined"
            onClick={openChangesDrawer}
            sx={{
              backgroundColor: '#fff',
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: '#efefef',
              },
            }}
            color="info"
          >
            Changes
          </Button>
        )}
      </Toolbar>
      {isNetworkActive && <LinearProgress color="primary" />}
      <Snackbar open={!!error} autoHideDuration={5000} onClose={clearError}>
        <Alert
          onClose={clearError}
          severity="error"
          sx={{ whiteSpace: 'pre-line' }}
        >
          {error}
        </Alert>
      </Snackbar>
      <Snackbar open={!!success} autoHideDuration={5000} onClose={clearSuccess}>
        <Alert onClose={clearSuccess} severity="success">
          {success}
        </Alert>
      </Snackbar>
    </AppBar>
  );
}

export default memo(Header);
